var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import React from 'react';
function LinkOverlayComponent(props, ref) {
    const { isExternal = false, target, rel, className, children, component = 'a' } = props, rest = __rest(props, ["isExternal", "target", "rel", "className", "children", "component"]);
    const Component = component;
    return (_jsx(Component, Object.assign({ ref: ref, className: `ui__link__overlay ${className ? className : ''}`, css: {
            position: 'static',
            textDecoration: 'none',
            color: 'inherit',
            '&::before': {
                content: '""',
                cursor: 'inherit',
                display: 'block',
                position: 'absolute',
                top: 0,
                left: 0,
                zIndex: 0,
                width: '100%',
                height: '100%',
            },
        } }, rest, { rel: isExternal ? 'noopener noreferrer' : rel, target: isExternal ? '_blank' : target, children: children })));
}
/**
 * A component used to wrap and entire element in a link while staying semantic and accessible. Should be used with LinkOverlayContainer.
 *
 * @example
 *<LinkOverlayContainer>
 * <LinkOverlay href='https://www.example.com/'>Link text</LinkOverlay>
 *</LinkOverlayContainer>
 *
 */
export const LinkOverlay = React.forwardRef(LinkOverlayComponent);
